export default "__VITE_ASSET__DkIZK_LR__"